import {
  PdfIcon,
  DpmIcon,
  CadIcon,
  ImgIcon,
  DraftRibbonIcon,
} from "../components/icons";

// File types accepted as direct DPM-generation input via chat drag-and-drop.
// STEP (CAD) files, PDFs, and images only — DPM files and everything else
// (ZIP, etc.) are deliberately excluded, same as folders.
const DPM_INPUT_FILE_TYPES = new Set([
  "PDF",
  "STEP",
  "CAD",
  "IMAGE",
  "IMG",
  "JPG",
  "JPEG",
  "PNG",
  "SVG",
]);

export const isDpmInputFileType = fileType =>
  DPM_INPUT_FILE_TYPES.has((fileType || "").toUpperCase());

// Chat history only stores file_id/file_name for attached files (no
// file_type) — infer it from the extension so historical attachments still
// show the correct type icon.
const EXTENSION_TO_FILE_TYPE = {
  pdf: "PDF",
  step: "CAD",
  stp: "CAD",
  dpm: "DPM",
  jpg: "JPG",
  jpeg: "JPG",
  png: "PNG",
  svg: "SVG",
};

export const getFileTypeFromFileName = file_name => {
  const ext = file_name?.split(".").pop()?.toLowerCase();
  return EXTENSION_TO_FILE_TYPE[ext] || null;
};

// Shared file-type → icon component lookup, used by any small chip/preview
// that needs to show a file's type icon (attached-file chips, drag ghosts, etc).
export const getFileTypeIcon = (type, dpmStatus) => {
  switch (type?.toUpperCase()) {
    case "PDF":
      return PdfIcon;
    case "DPM":
      return dpmStatus === "DRAFT" ? DraftRibbonIcon : DpmIcon;
    case "CAD":
      return CadIcon;
    case "JPG":
    case "JPEG":
    case "SVG":
    case "PNG":
    case "IMG":
    case "IMAGE":
      return ImgIcon;
    default:
      return null;
  }
};
